module.exports = __webpack_public_path__ + "img/diagram-rectangleBorder.47dcc100.svg";